import { render } from "./RedirectToRegister.vue?vue&type=template&id=2b7c200f&scoped=true&ts=true"
import script from "./RedirectToRegister.ts?vue&type=script&lang=ts&external"
export * from "./RedirectToRegister.ts?vue&type=script&lang=ts&external"

import "./RedirectToRegister.scss?vue&type=style&index=0&id=2b7c200f&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7c200f"]])

export default __exports__